<template>
  <div class="cause-search">
    <form
      class="input-search-container flex-grow flex"
    >
      <input
        class="w-full"
        type="text"
        ref="search"
        v-model="values.address"
        placeholder="Search for a city, or address"
        @input="setDefault"
        @blur="validateField"
      />
    </form>
    <div class="mt-2 mb-8">
      <span class="error" v-if="check && values.address && !values.lat && !values.lng">
        Please put a valid address {{values.lat}} {{values.lng}}
      </span>
  </div>
  </div>
</template>
<script>
export default {
  mounted () {
    this.initMap()
  },
  data () {
    return {
      autocomplete: null,
      values: {},
      check: false
    }
  },
  methods: {
    initMap () {
      const input = this.$refs.search
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ["address_components", "geometry"]
      });
      google.maps.event.addListener(this.autocomplete, "place_changed", () => {
        let place = {
          address_components: [],
          ...this.autocomplete.getPlace()
        }
        this.values.lat = null
       this.values.lng = null
        this.extractAddress(place)
      })
    },
    extractAddress (place) {
      this.values.address = this.$refs['search'].value
      this.values.lat = place.geometry.location.lat()
      this.values.lng = place.geometry.location.lng()
      this.values.title = ""
      if(this.values.address && this.values.lat && this.values.lng) {
        this.$emit('set-location-form', this.values)
      }
    },
    setDefault () {
      this.check = false
      this.values.lat = null
      this.values.lng = null
    },
    validateField () {
      setTimeout(() => {
        this.check = true
      }, 500)
    },
  }
}
</script>